import React, {
    useState,
    useCallback,
    useContext,
    useEffect,
    useMemo,
} from "react";
import _, { get } from "lodash";
import PropTypes from "prop-types"
import {  withViewModelService,ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';

;
import { withRouter } from "react-router-dom";
import { useTranslator } from "@jutro/locale";
import { MetadataContent } from "@jutro/legacy/uiconfig";
import { ServiceRequestService } from "gw-capability-servicerequest";
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import {  ModalNextContext } from "@jutro/components";
import { LoaderExt } from 'gw-components-platform-react';
import moment from "moment";
import PayrollService from "cpmi-capability-payroll/services/PayrollService";
import useGoogleAnalytics from "account-management/src/hooks/useGoogleAnalytics";
import metadata from "./PayrollReviewMEL.metadata.json5";
import messages from "./PayrollReviewMEL.messages";
import styles from "./PayrollReviewMEL.module.scss";

function PayrollReviewMEL(props) {
    
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const [state,setStateName]=useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const [viewStartPage, setviewStartPage] = useState(true);
    const [trackGAPageView]=useGoogleAnalytics();
    const [draftData,setDraftData]=useState({})
    const ModalNext = useContext(ModalNextContext);

    const { history } = props;
    const {onCallback,DraftDataFromReview} = props;
    const appValue=props?.location?.state?.appValue
    let reviewData;
    let totalsArray =[];
    if(appValue==="CE")
    {
        reviewData = _.get(props, "location.state.data");    
    }
    else{
        reviewData = _.get(props, "data");
       
    }

    useEffect(() => {
        trackGAPageView("/payroll-reporting/reviewMEL","Payroll Review")
    },[])
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const individualData=reviewData?.melStatePremiums!==undefined?reviewData?.melStatePremiums?.individualCosts:[]
    
    const handleSubmit = useCallback(() => {
        setLoadingState(true)
        ModalNext.showConfirm({
            title: messages.submitTitleGL,
            message: appValue==="PE"?messages.PEsubmitMessageGL:messages.submitMessageGL,
            status: "info",
            icon: "mi-error-outline",
            confirmButtonText: "Submit Report",
            cancelButtonText: "Edit Report",
            closeButton:"false"
        }).then(async (results) => {
            if (results === "confirm") {
                if (appValue === "PE") {
                    await PayrollService.PEsubmitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({pathname:props.location.peMainPayrollPath,state:"submitted",policyNumber:reviewData.policyNumber})
                } else {
                    await PayrollService.submitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({
                        pathname: `/payroll-reporting/list/success`,
                        state: {
                            appValue: "submitted",
                        },
                    });
                }
            } else if(appValue==='PE')
            {
                onCallback(true)
            }
            else{
                history.go(-1);
               
            }
        }, _.noop);
    }, [ModalNext, appValue, authHeader, history, onCallback, props.location.pathname, reviewData?.jobNumber]);

    const handleMakeChanges = useCallback(async() => {
       
        if(appValue==='PE')
        {
            const res = await PayrollService.PEchangeReportStatusToDraft(reviewData?.jobNumber,authHeader)
            setDraftData(res)
            setviewStartPage(true);
            onCallback(true)
            DraftDataFromReview(draftData)
        }
        else{
            await PayrollService.changeReportStatusToDraft(reviewData?.jobNumber,authHeader)            
        }

        history.push({
            pathname: `/payroll-reporting/startpayrollMEL`,
            state: {
                jobNumber: reviewData?.jobNumber,payrollFlag:"Edit Payroll",page:"Start",appValue:appValue
            },
        })
          
    }, [DraftDataFromReview, appValue, authHeader, draftData, history, onCallback, reviewData?.jobNumber]);

    const getFormatAmt = (value) => {
        // value=value.toFixed(2)
        var val = Math.round(Number(value) * 100) / 100;

        var parts = val.toFixed(2).split(".");

        var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");

        return num
    }

    const getTotalAmount = useCallback(() => {
        
        if(reviewData?.melTotalPolicyPremium!==undefined)
        {
            const amount = reviewData?.melTotalPolicyPremium.toFixed(
                2
            );
            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})
            return <span className={styles.textAlignment}>Total Premium: ${getFormatAmt(amount)}</span>;
        }
        
        return ' '
        
        
    }, [reviewData?.melStatePremiums, totalsArray]);

    const getTotalAmountTop = useCallback(() => {
        
        if(reviewData?.melTotalPolicyPremium!==undefined)
        {
            const amount = reviewData?.melTotalPolicyPremium?.toFixed(
                2
            );
            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})
            return <span className={styles.textAlignmentTop}>${amount}</span>;
        }
        
        return ' '
        
        
    }, [reviewData?.melTotalPolicyPremium, totalsArray]);


    const getPolicyPeriod = useCallback(() => {

        
        const startperiod = moment(reviewData?.reportPeriodStart).format(
            "MM/DD/YYYY"
        );
        const endDate = moment(reviewData?.reportPeriodEnd).format("MM/DD/YYYY");
        if(reviewData?.hasOwnProperty('paymentFrequency')){
            const paymentFrequency= reviewData?.paymentFrequency;
            return `Payroll Period : ${startperiod} - ${endDate} - (${paymentFrequency})`;
        }
        return `Payroll Period : ${startperiod} - ${endDate} `;
       
    }, [reviewData]);

    const renderPremiumAmountFormat = useCallback((amountValue) => {
        

        if(amountValue!==undefined)
        {
            const amount = amountValue.toFixed(
                2
            );

            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})

            return `$${  getFormatAmt(amount)}`;
        }
        
        return ' '
        
        
    }, [totalsArray]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const renderOtherTable = useCallback((mainLoopStandard) =>{

      return mainLoopStandard?.otherMelPremiums?.map((standardItemLoop)=>{
          return  <div className={styles.bodyContentClass}>
                             <div className={styles.bodyContentClassStyle}>{standardItemLoop.locationNum}</div>
                             <div className={styles.bodyContentClassStyle}>{standardItemLoop.melClassCode}</div>
                             <div className={styles.bodyContentClassStyle}>{standardItemLoop.description}</div>
                             <div className={styles.bodyContentClassStyle}>{parseInt(standardItemLoop.auditedPayroll)}</div>
                             <div className={styles.bodyContentClassStyle}>{standardItemLoop.rate}</div>
                             <div className={styles.bodyContentClassStyleAmount}>{renderPremiumAmountFormat(standardItemLoop.auditedPremium.amount)}</div>
                         </div> 

        })
   
        },[])
    
        
        const renderStandardTable = useCallback((mainLoopStandard) =>{
          return mainLoopStandard?.standardMelPremiums?.map((standardItemLoop)=>{
              return <div className={styles.bodyContentClass}>
                                 <div className={styles.bodyContentClassStyle}>{standardItemLoop.locationNum}</div>
                                 <div className={styles.bodyContentClassStyle}>{standardItemLoop.melClassCode}</div>
                                 <div className={styles.bodyContentClassStyle}>{standardItemLoop.description}</div>
                                 <div className={styles.bodyContentClassStyle}>{parseInt(standardItemLoop.auditedPayroll)}</div>
                                 <div className={styles.bodyContentClassStyle}>{standardItemLoop.rate}</div>
                                 <div className={styles.bodyContentClassStyleAmount}>{renderPremiumAmountFormat(standardItemLoop.auditedPremium.amount)}</div>
                             </div> 
           })
        },[])
        
   

    const generateTableMEL = useCallback(() => (
        
        reviewData?.melStatePremiums?.map((mainStateItem)=>{
          return  <div>
            
            <div className={styles.jurictionNameClassMEL}>{mainStateItem.stateCode}</div>
            <hr className={styles.hrStylePadding}></hr>
                <div className={styles.jurictionNameClassPremiumLable}>Standard Premium</div>
               <div className={styles.mainHeaderClass}>
               <div className={styles.headerStyleClass}>Loc.</div>
                   <div className={styles.headerStyleClass}>Code</div>
                   <div className={styles.headerStyleClass}>Description</div>
                   <div className={styles.headerStyleClass}>Basis</div>
                   <div className={styles.headerStyleClass}>Rate</div>
                   <div className={styles.headerStyleClassPremium}>Amount</div>
               </div>

               <div>{renderStandardTable(mainStateItem)}</div>

               <div className={styles.mainHeaderClassTotalsBottom}>
               <div></div>
                   <div></div>
                   <div></div>
                   <div></div>
                   <div className={styles.totalsAmountlabelStyle}>Total Premium Amount</div>
                   <div className={styles.totalsAmountAlign}>{renderPremiumAmountFormat(mainStateItem.totalStandardPremium.amount)}</div>                   
               </div>

               
               <div className={styles.jurictionNameClassPremiumLableOther}>Other Premium and Surcharges</div>
              
               <div className={styles.mainHeaderClass}>
               <div className={styles.headerStyleClass}>Loc.</div>
                   <div className={styles.headerStyleClass}>Code</div>
                   <div className={styles.headerStyleClass}>Description</div>
                   <div className={styles.headerStyleClass}>Basis</div>
                   <div className={styles.headerStyleClass}>Rate</div>
                   <div className={styles.headerStyleClassPremium}>Amount</div>
               </div>
               <div>{renderOtherTable(mainStateItem)}</div>
               <div className={styles.mainHeaderClassTotalsBottom}>
               <div></div>
                   <div></div>
                   <div></div>
                   <div></div>
                   <div className={styles.totalsAmountlabelStyle}>{mainStateItem.stateCode} Total Premium</div>
                   <div className={styles.totalsAmountAlign}>{renderPremiumAmountFormat(mainStateItem.totalOtherPremium.amount)}</div>
               </div>
               
                       </div>
        })
    
           
        ), [renderOtherTable, renderStandardTable, reviewData?.melStatePremiums])
    

    

    // const generateOverrides = useMemo(() => {
       
    //     let overrides={}
    //     if(appValue==="CE")
    //     {
    //         overrides = individualData?.map((item, index) => {
    //             return {
    //                 [`invoiceTable${index}`]: {
    //                     data: individualData[index],
    //                 },
                  
                    
    //             };
    //         });
    //     }
    //     else{
    //         overrides = individualData?.map((item, index) => {
    //             return {
    //                 [`invoiceTable${index}`]: {
    //                     data: individualData[index],
    //                 },
                  
                    
    //             };
    //         });  
    //     }

    //     return Object.assign({}, ...overrides);
    // }, [appValue, individualData]);

    

    const override = {
        
        // ...generateOverrides,
        
        policyNumberId: {

            content: `Policy : ${reviewData?.policyNumber}`,
        },
        policyperiodId: {
            content: getPolicyPeriod(),
        },
        totalcostdataId: {
            // value: `$${reviewData.policyPremium.totalPremiumOfReport.amount.toFixed(2)}`
            content: getTotalAmount(),
        },
        totalcostdataIdTop:{
            content: getTotalAmountTop(),
        },
        // payrollDetails:{
        //     data:individualData || []
        // },
        // totalDescId:{
        //     value:"Description"
        // },
        // totalAmountId:{
        //     value: getTotalAmount(),
        // }
        // payrollTotalTable:{
        //     visible:false,
        //     data:totalsArray
        // },

        tableDivMEL:{
            content:generateTableMEL()
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        
        resolveCallbackMap: {
            handleMakeChanges: handleMakeChanges,
            handleSubmit: handleSubmit,
        },
        resolveComponentMap:{
            
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }


    return <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={override}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
/>
}
PayrollReviewMEL.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({}),
        }),
    }).isRequired,
};

export default withRouter(withViewModelService(PayrollReviewMEL));
